import { render, staticRenderFns } from "./retest.vue?vue&type=template&id=e5654836&scoped=true"
import script from "./retest.vue?vue&type=script&lang=js"
export * from "./retest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5654836",
  null
  
)

export default component.exports